export default "__VITE_ASSET__CgLhR42w__"